<template>
<div class="live-wrapper">
      <iframe
      v-if="target_url"
    :src="target_url"
    frameborder="0"
    width="100%"
    height="100%"
  ></iframe>
</div>
</template>

<script>
import { mapMutations } from "vuex";
export default {
    data(){
        return {
            news_id:null,
            target_url:null
        }
    },
  created() {
    this.news_id = this.$route.params.id;
    this.target_url =(this.$route.query.targetUrl);
    this.setIsShowWapHeader(false);
    this.setIsShowWapFooter(false);
    this.setLoadingShow(false);
    this.getDetail();
  },
  beforeDestroy() {
    this.setIsShowWapHeader(true);
    this.setIsShowWapFooter(true);
    this.setMetaInfo()
  },
  methods: {
    ...mapMutations(["setIsShowWapHeader", "setLoadingShow","setIsShowWapFooter"]),
     getDetail() {
      this.$axios
        .post(
          this.$ApiInfo.getNewsDetail,
          "data=" +
            JSON.stringify({
              news_id: this.news_id
            }),
          false
        ) 
        .then(data => {
          this.setLoadingShow(false);
          this.setMetaInfo(data.news_title, data.brief || this.getDescription(data.content), data.imgs_url)
         this.$nextTick(()=>{
           this.$Common.onShare({
            shareTitle: data.share_title,
            shareBrief: data.share_brief,
            // shareImg: data.share_img,
            shareImg:require('../../assets/img/share_defalut.png'),
            shareUrl:window.location.href
          });
         })
        });
    }
  }
};
</script>

<style lang='less' scoped>
.live-wrapper{
    height: 100vh;
}
</style>